import React, { useState, useEffect } from "react";
import Fotter from "../components/Fotter";
import Navbar from "../components/Navbar";
import { Link, useNavigate, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { BASE_URL } from "./Config";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import Select from "react-select";
import imageCompression from "browser-image-compression";

import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
export default function ListitemEdit() {
  const { id } = useParams();
  const user_id = Cookies.get("user_id");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [newsItem, setNewsItem] = useState(null);
  const [formData, setFormData] = useState({});
  const [previewImages, setPreviewImages] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [sessionuser, setUser] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [formTouched, setFormTouched] = useState({});
  const [category, setcategory] = useState([]);
  const [imagelodaer, setImageLoading] = useState(false);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_user_by_id.php?id=${user_id}&t=${Date.now()}`)
      .then((res) => {
        if (res.data.success) {
          setUser(res.data.data);
        }
      })
      .catch((err) => console.error("User fetch error:", err));
  }, []);

  useEffect(() => {
    if (!id) return;
    fetch(`${BASE_URL}/get_item_by_id.php?id=${id}&t=${Date.now()}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.data.length > 0) {
          const item = data.data[0];
          setNewsItem(item);
          setFormData({
            id: item.id,
            user_id: item.user_id || "",
            username: item.username || "",
            title: item.title || "",
            category: item.category || "",
            main_image: item.main_image ? item.main_image.split(",") : [],
            useproductDes: item.usedescription || "",
            desc: item.description || "",
            quantity: item.quantity || "",
            location: item.location || "",
            city: item.city || "",
            neighborhood: item.neighborhood || "",
            listingType: item.listing_type || "",
            productType: item.product_type || "",
            auctionStartPrice: item.auction_start_price || "",
            desiredPrice: item.desired_price || "",
            buy_now: item.buy_now || "",
            closingTime: item.closing_time || "",
            closingTimeWord: item.closing_time_word || "",
            shipping: item.shipping || "",
            // sheppingDes: item.sheppingDes || "",
            // shippingCost: item.shippingCost || "",
            // freeshipping: item.freeshipping || "",
            // shippingCity: item.shippingCity || "",
            photos: item.photo ? item.photo.split(",") : [],
          });
          const existingImageURLs = item.photo
            ? item.photo.split(",").map((img) => `${BASE_URL}/${img}`)
            : [];
          setPreviewImages(existingImageURLs);
        }
      })
      .catch((err) => console.error("Item fetch error:", err));
  }, [id]);

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const updateFormData = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    setFormTouched((prev) => ({ ...prev, [key]: true }));

    if ((value || "").toString().trim() !== "") {
      setFormErrors((prev) => ({ ...prev, [key]: null }));
    }
  };

  const isMobile =
    /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
      navigator.userAgent,
    );

  let updateFormData2;

  if (isMobile) {
    updateFormData2 = async (files) => {
      const incoming = Array.from(files);
      const newImages = [];

      for (let file of incoming) {
        if (!file || !file.size) continue;

        // Fix empty file.type
        if (!file.type || file.type === "") {
          file = new File([file], file.name || "image.jpg", {
            type: "image/jpeg",
          });
        }

        // Convert HEIC → JPEG
        if (file.type.includes("heic") || file.name.endsWith(".heic")) {
          try {
            file = await imageCompression(file, {
              fileType: "image/jpeg",
              maxWidthOrHeight: 1280,
            });
          } catch (e) {
            console.log("HEIC conversion failed", e);
          }
        }

        let compressedBlob = file;

        // 🔥 Compress to 50 KB
        try {
          compressedBlob = await imageCompression(file, {
            maxSizeMB: 0.05, // 50 KB
            maxWidthOrHeight: 1000,
            maxIteration: 10,
            useWebWorker: true,
          });
        } catch (e) {
          console.log("Compression failed:", e);
        }

        // Skip if still too big
        if (compressedBlob.size > 50 * 1024) {
          console.log(`SKIPPED: still > 50KB (${compressedBlob.size} bytes)`);
          continue;
        }

        // 🔥 REAL FIX: Convert Blob → File (MOBILE NEEDS THIS)
        const compressedFile = new File(
          [compressedBlob],
          file.name || "image.jpg",
          { type: "image/jpeg" },
        );

        const previewURL = URL.createObjectURL(compressedFile);

        newImages.push({
          file: compressedFile, // <-- REAL FILE (WORKS IN BACKEND)
          preview: previewURL,
        });
      }

      setFormData((prev) => {
        const prevPhotos = Array.isArray(prev.photos) ? prev.photos : [];
        return {
          ...prev,
          photos: [...prevPhotos, ...newImages].slice(0, 5),
        };
      });
    };
  } else {
    updateFormData2 = async (files) => {
      const incomingFiles = Array.from(files);

      const newImages = await Promise.all(
        incomingFiles.map(async (file) => ({
          file,
          preview: URL.createObjectURL(file),
          base64: await fileToBase64(file),
        })),
      );

      // ➕ append previous + new
      setFormData((prev) => ({
        ...prev,
        photos: [...(prev.photos || []), ...newImages].slice(0, 5),
      }));
    };
  }

  const handleFiles = (files) => {
    setImageLoading(true);
    if (isMobile) {
      updateFormData2(files); // handle mobile conversions/compression
    } else {
      updateFormData2(files); // desktop also goes through same pipeline
    }

    setImageLoading(false);
  };

  function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    setImageLoading(true);

    const items = reorder(
      formData.photos,
      result.source.index,
      result.destination.index,
    );

    setFormData((prev) => ({ ...prev, photos: items }));

    setImageLoading(false);
  };

  const removeImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      photos: prev.photos.filter((_, i) => i !== index),
    }));
  };

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const errors = {};

    if (!formData.title.trim()) {
      errors.title = "Item title is required";
    } else if (formData.title.trim().length < 2) {
      errors.title = "Title must be at least 2 characters long";
    }
    if (!formData.listingType) errors.listingType = "Listing type is required";
    if (!formData.productType) errors.productType = "Product type is required";
    if (!formData.location) errors.location = "Location is required";

    // if (
    //   formData.auctionStartPrice.trim() !== "" &&
    //   formData.desiredPrice.trim() === ""
    // ) {
    //   errors.desiredPrice = "Desired price is required";
    // }

    const start = parseFloat(formData.auctionStartPrice);
    const desired = parseFloat(formData.desiredPrice);

    if (!isNaN(desired) && !isNaN(start)) {
      const minDesired = start + start * 0.1;
      if (desired < minDesired) {
        errors.desiredPrice = `Desired price must be at least 10% more than start price (₹${minDesired.toFixed(
          2,
        )})`;
      }
    }

    if (formData.listingType === "Auctionwithbuy") {
      const desiredPrice = parseFloat(formData.desiredPrice);
      const buyNow = parseFloat(formData.buy_now);
      if (!formData.buy_now.trim()) {
        errors.buy_now = "Buy Now price is required";
      } else if (
        !isNaN(desiredPrice) &&
        !isNaN(buyNow) &&
        buyNow <= desiredPrice
      ) {
        errors.buy_now = `Buy Now price must be greater than desired price (₹${desiredPrice.toFixed(
          2,
        )})`;
      }
    }

    if (!formData.closingTime) {
      errors.closingTime = "Closing Time is required";
    }

    if (sessionuser?.membership_type != "Basic") {
      const today = new Date().toISOString().split("T")[0];
      if (formData.closingTime < today) {
        errors.closingTime = "Closing Time cannot be in the past";
      }
    }

    if (sessionuser?.membership_type !== "Basic") {
      const today = new Date();
      const minDate = new Date();
      minDate.setDate(today.getDate() + 2); // +2 days

      const selectedDate = new Date(formData.closingTime);

      if (selectedDate < minDate) {
        errors.closingTime = "Closing Time must be at least 2 days from today";
      }
    }

    setErrors(errors);

    // ✅ Scroll to first error
    if (Object.keys(errors).length > 0) {
      const firstErrorKey = Object.keys(errors)[0];
      const element = document.querySelector(`[name="${firstErrorKey}"]`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        element.focus();
      }
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    // if (!formData.main_image || formData.main_image.length === 0) {
    //   toast.warning("Main Image Required !");
    //   return; // ⛔ stop function here
    // }
    setLoading(true);

    // Step 1: Validate form
    if (!validateForm()) {
      setLoading(false);
      return;
    }

    const isSilverOrGold =
      sessionuser?.membership_type === "Silver" ||
      sessionuser?.membership_type === "Gold";

    // Step 2: Compute closingTimeValue based on membership and selected option
    let closingTimeValue;
    let selected = isSilverOrGold
      ? formData.closingTime
      : formData.closingTimeWord; // Could be "3min", "7", ISO string etc.
    let now = new Date();

    // console.log("Selected value:", selected, "| Type:", typeof selected);
    // console.log("Current system date:", now.toISOString());

    if (isSilverOrGold) {
      if (selected && !isNaN(Date.parse(selected))) {
        closingTimeValue = new Date(selected).toISOString();
      } else {
        console.error("Invalid datetime:", selected);
        setLoading(false);
        setErrors((prev) => ({
          ...prev,
          closingTime: "Closing Time is required",
        }));
        return;
      }
    } else {
      // Relative time logic
      if (selected === "1min") {
        now.setMinutes(now.getMinutes() + 1);
      } else if (selected === "3min") {
        now.setMinutes(now.getMinutes() + 3);
      } else if (selected === "10min") {
        now.setMinutes(now.getMinutes() + 10);
      } else {
        const numDays = parseInt(selected);
        if (!isNaN(numDays)) {
          now.setDate(now.getDate() + numDays);
        } else {
          // Invalid value
          console.error("❌ Invalid value for closingTime:", selected);
          setFormData((prev) => ({
            ...prev,
            closingTime: "",
          }));
          setLoading(false);
          return;
        }
      }

      closingTimeValue = now.toISOString();
      console.log("Relative time (calculated):", closingTimeValue);
    }

    const sendData = new FormData();

    // append all other fields
    for (let key in formData) {
      if (key !== "photos") sendData.append(key, formData[key]);
    }

    // append photos[] — old images as string, new images as File
    formData.photos.forEach((item) => {
      if (typeof item === "string") {
        // old image path
        sendData.append("photos_old[]", item);
      } else {
        // new file
        sendData.append("photos[]", item.file || item);
      }
    });

    // if (formData.shipping === "No") {
    //   sendData.set("sheppingDes", "");
    //   sendData.set("shippingCity", "");
    //   sendData.set("shippingCost", "");
    //   sendData.set("freeshipping", "");
    // }

    sendData.set("user_id", user_id);
    sendData.set("closingTime", closingTimeValue);
    sendData.set("closingTimeWord", selected);

    // Final debug logs

    // console.log("🟢 FormData: closingTime =", sendData.get("closingTime"));
    // console.log(
    //   "🟢 FormData: closingTimeWord =",
    //   sendData.get("closingTimeWord")
    // );

    // Step 4: Submit to backend
    try {
      const res = await fetch(`${BASE_URL}/list-item-update.php`, {
        method: "POST",
        body: sendData,
      });

      // Check if the server responded properly
      const text = await res.text();
      let result;

      try {
        result = JSON.parse(text); // Try to parse the response as JSON
      } catch (e) {
        console.error("❌ Failed to parse response:", text);
        throw new Error("Invalid response format");
      }

      // ✅ Case 1: Success from backend
      if (result.success === true) {
        Swal.fire({
          icon: "success",
          title:
            "<h3 style='color:#28a745; font-weight:bold;'>🎉 Success!</h3>",
          html: `
        <p style="font-size:16px; color:#333; margin:8px 0;">
          Your item is now <b style="color:#28a745;">Live</b> 🚀
        </p>
        <p style="font-size:14px; color:#666; margin:0;">
          Buyers can now view and place bids on it.
        </p>
      `,
          background: "linear-gradient(135deg, #f0fff4, #d4edda)",
          confirmButtonColor: "#28a745",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        toast.success("Item Live Successfully!");
        localStorage.removeItem("listItemData");
        localStorage.removeItem("listItemStep");
        navigate("/setting");
      } else {
        // ⚠️ Case 2: Backend returned success: false
        Swal.fire({
          icon: "warning",
          title: "Something went wrong!",
          text: result.message || "Please try again later.",
          confirmButtonColor: "#dc3545",
        });
      }
    } catch (error) {
      // ❌ Case 3: Network failure or fetch failed
      console.error("❌ Network or server error:", error);
      Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Failed to connect to server. Please check your internet or try again later.",
        confirmButtonColor: "#dc3545",
      });
    }

    setLoading(false);
  };

  const handleDraftSubmit = async () => {
    setLoading(true);

    // if (!validateForm()) {
    //   setLoading(false);
    //   return;
    // }

    const user_id = Cookies.get("user_id");
    if (!user_id) {
      toast.error("User not logged in");
      setLoading(false);
      return;
    }

    // ==========================
    // Calculate closingTimeValue
    // ==========================

    const isSilverOrGold =
      sessionuser?.membership_type === "Silver" ||
      sessionuser?.membership_type === "Gold";

    let closingTimeValue;
    let selected = isSilverOrGold
      ? formData.closingTime
      : formData.closingTimeWord; // Could be "3min", "7", ISO string etc.
    let now = new Date();

    console.log("Selected value:", selected, "| Type:", typeof selected);
    console.log("Current system date:", now.toISOString());

    if (isSilverOrGold) {
      if (selected && !isNaN(Date.parse(selected))) {
        closingTimeValue = new Date(selected).toISOString();
      } else {
        console.error("Invalid datetime:", selected);
        setLoading(false);
        setErrors((prev) => ({
          ...prev,
          closingTime: "Closing Time is required",
        }));
        return;
      }
    } else {
      // Relative time logic
      if (selected === "1min") {
        now.setMinutes(now.getMinutes() + 1);
      } else if (selected === "3min") {
        now.setMinutes(now.getMinutes() + 3);
      } else if (selected === "10min") {
        now.setMinutes(now.getMinutes() + 10);
      } else {
        const numDays = parseInt(selected);
        if (!isNaN(numDays)) {
          now.setDate(now.getDate() + numDays);
        } else {
          // Invalid value
          console.error("❌ Invalid value for closingTime:", selected);
          setFormData((prev) => ({
            ...prev,
            closingTime: "",
          }));
          setLoading(false);
          return;
        }
      }

      closingTimeValue = now.toISOString();
      // console.log("Relative time (calculated):", closingTimeValue);
    }

    // Step 3: Prepare form data
    const sendData = new FormData();

    // append all other fields
    for (let key in formData) {
      if (key !== "photos") sendData.append(key, formData[key]);
    }

    // append photos[] — old images as string, new images as File
    formData.photos.forEach((item) => {
      if (typeof item === "string") {
        // old image path
        sendData.append("photos_old[]", item);
      } else {
        // new file
        sendData.append("photos[]", item.file || item);
      }
    });

    sendData.set("user_id", user_id);
    sendData.set("closingTime", closingTimeValue);
    sendData.set("closingTimeWord", selected);

    for (let pair of sendData.entries()) {
      console.log(pair[0] + ": ", pair[1]);
    }

    // if (formData.shipping === "No") {
    //   sendData.set("sheppingDes", "");
    //   sendData.set("shippingCity", "");
    //   sendData.set("shippingCost", "");
    //   sendData.set("freeshipping", "");
    // }

    sendData.set("user_id", user_id);
    sendData.set("closingTime", closingTimeValue);
    sendData.set("closingTimeWord", selected);

    try {
      const res = await fetch(`${BASE_URL}/list-item-update.php?type=draft`, {
        method: "POST",
        body: sendData,
      });

      const rawText = await res.text();
      console.log("Raw Response:", rawText);

      let response;
      try {
        response = JSON.parse(rawText);
      } catch {
        throw new Error("Invalid JSON response: " + rawText);
      }

      if (!response.success) {
        throw new Error(response.message || "Draft save failed");
      }

      setLoading(false);
      await Swal.fire({
        icon: "success",
        title: "💾 Draft Saved!",
        text: response.message || "You can continue editing later 🚀",
        confirmButtonColor: "#28a745",
        timer: 3000,
        timerProgressBar: true,
      });

      toast.success(response.message || "Save Draft Successfully!");
      localStorage.removeItem("listItemData");
      localStorage.removeItem("listItemStep");
      navigate("/drafts");
    } catch (error) {
      console.error("Draft save failed", error);
      Swal.fire("Error", error.message || "Draft could not be saved!", "error");
    } finally {
      setLoading(false);
    }

    // try {
    //   const res = await fetch(`${BASE_URL}/list-item-update.php?type=draft`, {
    //     method: "POST",
    //     body: sendData,
    //   });
    //   const result = await res.text();

    //   // console.log("STATUS:", res.status);
    //   // console.log("RAW RESPONSE:", result);

    //   Swal.fire({
    //     icon: "success",
    //     title:
    //       "<h3 style='color:#28a745; font-weight:bold;'>💾 Draft Saved!</h3>",
    //     html: `
    //       <p style="font-size:16px; color:#333; margin:8px 0;">
    //         Your item has been <b style="color:#28a745;">saved as draft</b>.
    //       </p>
    //       <p style="font-size:14px; color:#666; margin:0;">
    //         You can continue editing anytime before making it live 🚀
    //       </p>
    //     `,
    //     background: "linear-gradient(135deg, #f9fdf9, #e6ffed)",
    //     confirmButtonColor: "#28a745",
    //     showConfirmButton: false,
    //     timer: 5000,
    //     timerProgressBar: true,
    //     didOpen: () => {
    //       Swal.showLoading();
    //     },
    //   });

    //   toast.success("Saved Successfully!");
    //   localStorage.removeItem("listItemData");
    //   localStorage.removeItem("listItemStep");
    //   navigate("/drafts");
    // } catch (error) {
    //   console.error("Submit error:", error);
    //   alert("Upload failed!");
    // }

    setLoading(false);
  };

  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const handleInputChange = async (value) => {
    if (value.length > 2) {
      setLoadingSuggestions(true);
      try {
        const response = await axios.get(`${BASE_URL}/location_search.php`, {
          params: { q: value },
        });
        setSuggestions(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        setSuggestions([]);
        setLoadingSuggestions(false);
      }
    } else {
      setSuggestions([]);
      setLoadingSuggestions(false);
    }
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_category.php?t=${Date.now()}`)
      .then((res) => {
        if (res.data.success && Array.isArray(res.data.data)) {
          setcategory(res.data.data);
        }
      })
      .catch(() => setcategory([]));
  }, []);

  const [locations, setlocation] = useState([]);
  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_location.php?t=${Date.now()}`)
      .then((res) => {
        if (res.data.success && Array.isArray(res.data.data)) {
          // console.log("All Location:", res.data.data);
          setlocation(res.data.data);
        } else {
          console.warn("API success true, but data is not array");
          setlocation([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setlocation([]);
      });
  }, []);

  const options = locations.map((loc) => ({
    value: loc.city_name,
    label: loc.city_name,
  }));

  const categoryOptions = category.map((cat) => ({
    value: cat.title, // must match your DB/API field
    label: cat.title,
  }));

  const closingTimeOptions = [
    { value: "3", label: "3 Days" },
    { value: "5", label: "5 Days" },
    { value: "7", label: "7 Days" },
  ];

  return (
    <>
      <Navbar />
      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME</p>
                </Link>
                <span>/</span>
                <p>List An item Update</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="list-item-page">
        <div className="container">
          {/* <div className="row">
           <div className="col-12">
              <div className="info" style={{ display: "flex", gap: "5px" }}>
                <p>Title & Category</p>
                <span>/</span>
                <p>Pricing & Duration</p>
                <span>/</span>
                <p>Shipping Options</p>
                <span>/</span>
                <p>Add Photos</p>
              </div>
            </div>
          </div>  */}

          <div className="row mb-5">
            <div className="col-12">
              <h2>
                <b>What are you listing?</b>
              </h2>
            </div>
            <div className="col-12 mt-3">
              <div className="add-detailpage">
                <div className="forms">
                  <p>
                    Item Title <span style={{ color: "red" }}>*</span>
                  </p>
                  <input
                    type="text"
                    name="title"
                    value={formData.title || ""}
                    onChange={(e) => updateFormData("title", e.target.value)}
                    className="form-control"
                  />
                  {errors.title && (
                    <p style={{ color: "red" }}>{errors.title}</p>
                  )}
                  <input
                    type="hidden"
                    value={formData.user_id}
                    onChange={(e) => updateFormData("user_id", e.target.value)}
                    className="form-control"
                  />
                  <input
                    type="hidden"
                    value={formData.username}
                    onChange={(e) => updateFormData("username", e.target.value)}
                    className="form-control"
                  />

                  <br />
                  <p>Categories</p>
                  <Select
                    options={categoryOptions} // 👈 MUST use "options"
                    value={
                      categoryOptions.find(
                        (opt) => opt.value === formData.category,
                      ) || null
                    }
                    onChange={(selected) =>
                      updateFormData("category", selected?.value || "")
                    }
                    placeholder="-- Select Categories --"
                    isClearable
                    isSearchable
                    filterOption={(option, inputValue) =>
                      option.label
                        .toLowerCase()
                        .startsWith(inputValue.toLowerCase())
                    }
                  />

                  {/* <br />
                  <p>Short Description (Optional)</p>
                  <textarea
                    rows="2"
                    value={formData.shortDesc}
                    onChange={(e) =>
                      updateFormData("shortDesc", e.target.value)
                    }
                    className="form-control"
                  ></textarea> */}

                  <br />
                  <p>Description (Optional)</p>
                  <textarea
                    rows="4"
                    value={formData.desc}
                    onChange={(e) => updateFormData("desc", e.target.value)}
                    className="form-control"
                  ></textarea>

                  <br />
                  <br />
                  <h2>
                    <b>
                      Item Location{" "}
                      <span style={{ color: "red", fontSize: "12px" }}>*</span>
                    </b>
                  </h2>
                  <Select
                    options={options}
                    value={
                      options.find((opt) => opt.value === formData.location) ||
                      null
                    }
                    onChange={(selected) => {
                      const value = selected?.value || "";
                      updateFormData("location", value);
                      updateFormData("city", value); // agar city bhi sync karni ho
                    }}
                    placeholder="-- Select Location --"
                    isClearable
                    isSearchable
                    filterOption={(option, inputValue) =>
                      option.label
                        .toLowerCase()
                        .startsWith(inputValue.toLowerCase())
                    }
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderColor: state.isFocused ? "#007bff" : "#ced4da",
                        boxShadow: state.isFocused
                          ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                          : "none",
                        "&:hover": { borderColor: "#007bff" },
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />

                  {formTouched.city && formErrors.city && (
                    <div className="invalid-feedback">{formErrors.city}</div>
                  )}

                  {errors.location && (
                    <p style={{ color: "red" }}>{errors.location}</p>
                  )}

                  <br />
                  <p>Neighborhood (Optional)</p>
                  <input
                    type="text"
                    value={formData.neighborhood}
                    onChange={(e) =>
                      updateFormData("neighborhood", e.target.value)
                    }
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-12">
              <h2>
                <b>Pricing & Duration</b>
              </h2>
            </div>
            <div className="col-12 mt-3">
              <div className="add-detailpage">
                <div className="forms">
                  <p>
                    Listing Type <span style={{ color: "red" }}>*</span>
                  </p>
                  <div className="form-check mt-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="onlyAuction"
                      name="listingType"
                      value="OnlyAuction"
                      checked={formData.listingType === "OnlyAuction"}
                      onChange={(e) =>
                        updateFormData("listingType", e.target.value)
                      }
                    />
                    <label className="form-check-label" htmlFor="onlyAuction">
                      Auction
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="auctionWithBuy"
                      name="listingType"
                      value="Auctionwithbuy"
                      checked={formData.listingType === "Auctionwithbuy"}
                      onChange={(e) =>
                        updateFormData("listingType", e.target.value)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="auctionWithBuy"
                    >
                      Auction & Buy Now
                    </label>
                  </div>

                  <br />

                  <p>
                    Product Type <span style={{ color: "red" }}>*</span>
                  </p>
                  <div className="form-check mt-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="productUsed"
                      name="productType"
                      value="used"
                      checked={formData.productType === "used"}
                      onChange={(e) =>
                        updateFormData("productType", e.target.value)
                      }
                    />
                    <label className="form-check-label" htmlFor="productUsed">
                      Used
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="productNotUsed"
                      name="productType"
                      value="notused"
                      checked={formData.productType === "notused"}
                      onChange={(e) =>
                        updateFormData("productType", e.target.value)
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="productNotUsed"
                    >
                      Not Used
                    </label>
                  </div>

                  {errors.productType && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "4px",
                      }}
                    >
                      {errors.productType}
                    </p>
                  )}

                  <br />

                  {formData.productType === "used" && (
                    <>
                      <br />
                      <p>Use Description (Optional)</p>
                      <textarea
                        rows="4"
                        value={newsItem.usedescription}
                        onChange={(e) =>
                          updateFormData("useproductDes", e.target.value)
                        }
                        className="form-control"
                      ></textarea>
                    </>
                  )}

                  <br />
                  <p>Auction Start Price (optional)</p>
                  <input
                    type="number"
                    value={
                      formData.auctionStartPrice > 0
                        ? formData.auctionStartPrice
                        : ""
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      // Only allow positive integers (no 0, no decimal)
                      if (/^\d+$/.test(value) && parseInt(value) > 0) {
                        updateFormData("auctionStartPrice", e.target.value);
                      } else if (value === "") {
                        updateFormData("auctionStartPrice", "");
                      }
                    }}
                    min="0"
                    step="0"
                    className="form-control"
                  />
                  {errors.auctionPrice && (
                    <p style={{ color: "red" }}>{errors.auctionPrice}</p>
                  )}

                  <br />
                  <p>Desired Price (optional)</p>
                  <input
                    type="number"
                    value={
                      formData.desiredPrice > 0 ? formData.desiredPrice : ""
                    }
                    onChange={(e) => {
                      const value = e.target.value;
                      // Only allow positive integers (no 0, no decimal)
                      if (/^\d+$/.test(value) && parseInt(value) > 0) {
                        updateFormData("desiredPrice", e.target.value);
                      } else if (value === "") {
                        updateFormData("desiredPrice", "");
                      }
                    }}
                    min="1"
                    step="1"
                    className={`form-control ${
                      formTouched.desiredPrice && formErrors.desiredPrice
                        ? "is-invalid"
                        : ""
                    }`}
                  />

                  {errors.desiredPrice && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "14px",
                        marginTop: "4px",
                      }}
                    >
                      {errors.desiredPrice}
                    </p>
                  )}

                  <br />
                  {formData.listingType === "Auctionwithbuy" && (
                    <>
                      <p>
                        Buy Now <span style={{ color: "red" }}>*</span>
                      </p>
                      <input
                        type="number"
                        value={formData.buy_now}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Only allow positive integers (no 0, no decimal)
                          if (/^\d+$/.test(value) && parseInt(value) > 0) {
                            updateFormData("buy_now", value);
                          } else if (value === "") {
                            updateFormData("buy_now", "");
                          }
                        }}
                        min="1"
                        step="1"
                        className="form-control"
                      />

                      {errors.buy_now && (
                        <p style={{ color: "red" }}>{errors.buy_now}</p>
                      )}
                    </>
                  )}

                  <br />
                  {/* Closing Time Section */}
                  <p>
                    Closing Time <span style={{ color: "red" }}>*</span>
                  </p>

                  {sessionuser?.membership_type === "Silver" ||
                  sessionuser?.membership_type === "Gold" ? (
                    // Silver & Gold → Show date picker
                    <input
                      name="closingTime"
                      type="datetime-local"
                      className="form-control"
                      style={{ color: "#000" }}
                      value={
                        formData.closingTime
                          ? formData.closingTime.replace(" ", "T")
                          : ""
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        updateFormData("closingTime", val.replace("T", " "));
                        updateFormData(
                          "closingTimeWord",
                          val.replace("T", " "),
                        );
                      }}
                      min={(() => {
                        const d = new Date();
                        d.setMinutes(d.getMinutes() + 5);
                        return d.toISOString().slice(0, 16);
                      })()}
                    />
                  ) : (
                    // Basic → Show select dropdown
                    <Select
                      options={closingTimeOptions}
                      value={
                        closingTimeOptions.find(
                          (opt) => opt.value === formData.closingTimeWord,
                        ) || null
                      }
                      onChange={(selected) => {
                        updateFormData("closingTime", selected?.value || "");
                        updateFormData(
                          "closingTimeWord",
                          selected?.value || "",
                        );
                      }}
                      placeholder="-- Select Closing Time --"
                      isClearable
                      isSearchable
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: state.isFocused ? "#007bff" : "#ced4da",
                          boxShadow: state.isFocused
                            ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                            : "none",
                          "&:hover": { borderColor: "#007bff" },
                        }),
                      }}
                    />
                  )}

                  {errors.closingTime && (
                    <p style={{ color: "red" }}>{errors.closingTime}</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-12">
              <h2>
                <b>Shipping Options </b>
              </h2>
            </div>
            <div className="col-12 mt-3">
              <div className="add-detailpage">
                <div className="forms">
                  <p>Shipping Options </p>
                  <div className="form-check mt-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="shippingYes"
                      name="shipping"
                      value="Yes"
                      checked={formData.shipping == "Yes"}
                      onChange={(e) =>
                        updateFormData("shipping", e.target.value)
                      }
                    />
                    <label className="form-check-label" htmlFor="shippingYes">
                      Shipping available
                    </label>
                  </div>

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="shippingNo"
                      name="shipping"
                      value="No"
                      checked={formData.shipping == "No"}
                      onChange={(e) =>
                        updateFormData("shipping", e.target.value)
                      }
                    />
                    <label className="form-check-label" htmlFor="shippingNo">
                      No shipping
                    </label>
                  </div>

                  {/* {formData.shipping === "Yes" && (
                    <>
                      <div style={{ marginTop: "10px" }}>
                        <input
                          type="text"
                          value={formData.shippingCity}
                          onChange={(e) =>
                            updateFormData("shippingCity", e.target.value)
                          }
                          placeholder="Shipping With in City"
                          className={`form-control ${
                            formErrors.shippingCity ? "is-invalid" : ""
                          }`}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <input
                          type="number"
                          value={formData.shippingCost}
                          onChange={(e) =>
                            updateFormData("shippingCost", e.target.value)
                          }
                          className={`form-control ${
                            formErrors.shippingCost ? "is-invalid" : ""
                          }`}
                          placeholder="Cost : 20 SAR"
                        />

                        <div
                          className="form-check"
                          style={{
                            width: "30%",
                            border: "1px solid #dee2e6",
                            borderRadius: "5px",
                            padding: "10px 35px",
                          }}
                        >
                          <input
                            id="shippingFree"
                            className={`form-check-input ${
                              formTouched.freeshipping &&
                              formErrors.freeshipping
                                ? "is-invalid"
                                : ""
                            }`}
                            type="radio"
                            name="shippingFree"
                            value="Yes"
                            checked={formData.freeshipping === "Yes"}
                            onChange={(e) => {
                              updateFormData("freeshipping", e.target.value);
                              setFormTouched((prev) => ({
                                ...prev,
                                shipping: true,
                              }));
                            }}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="shippingFree"
                            style={{ margin: " 2px 0 5px" }}
                          >
                            Free shipping
                          </label>
                        </div>
                      </div>

                      <div style={{ marginBottom: "10px" }}>
                        <textarea
                          rows="4"
                          value={formData.sheppingDes}
                          onChange={(e) =>
                            updateFormData("sheppingDes", e.target.value)
                          }
                          className="form-control"
                          placeholder="Description (Optional)"
                        ></textarea>
                      </div>
                    </>
                  )} */}

                  <p>Shipping options depend on user plan.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-12">
              <h2>
                <b>Add Photos</b>
              </h2>
            </div>
            <div className="col-12 mt-3">
              <div className="add-detailpage">
                <div className="forms" style={{ overflow: "hidden" }}>
                  <div className="col-12 mt-3">
                    <div
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        handleFiles(e.dataTransfer.files);
                      }}
                      className="border-2 border-dashed p-5 rounded text-center cursor-pointer d-flex align-items-center justify-content-center flex-column"
                      onClick={() =>
                        document.getElementById("file-gallery").click()
                      }
                      style={{
                        border: "1px dashed #00b1db",
                        cursor: "pointer",
                      }}
                    >
                      <img src="/logo/upload.png" width={100} /> <br />
                      <p style={{ fontWeight: 800 }}>
                        Drag & Drop Images
                        <br />
                        OR
                        <br />
                        Click to Upload
                      </p>
                    </div>

                    <input
                      type="file"
                      id="file-gallery"
                      multiple
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        handleFiles(e.target.files);
                        e.target.value = "";
                      }}
                    />

                    {imagelodaer && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          background: "rgba(255,255,255,0.7)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 9999,
                        }}
                      >
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                    {/* SORTABLE GRID */}
                    <DragDropContext onDragEnd={handleDragEnd}>
                      <Droppable droppableId="photos" direction="horizontal">
                        {(provided) => (
                          <div
                            className="row mt-3"
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            {(formData.photos || []).map((item, index) => {
                              const imageSrc =
                                typeof item === "string"
                                  ? `${BASE_URL}/${item}`
                                  : item.preview ||
                                    URL.createObjectURL(item.file);

                              return (
                                <Draggable
                                  key={index}
                                  draggableId={String(index)}
                                  index={index}
                                >
                                  {(provided) => (
                                    <div
                                      className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 mb-3"
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div className="position-relative">
                                        {index === 0 && (
                                          <span
                                            className="badge bg-warning text-dark position-absolute"
                                            style={{
                                              top: "5px",
                                              left: "5px",
                                              fontSize: "12px",
                                              padding: "3px 6px",
                                              borderRadius: "5px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Main Image
                                          </span>
                                        )}
                                        <img
                                          src={imageSrc}
                                          className="img-fluid rounded"
                                          style={{
                                            height: "150px",
                                            objectFit: "contain",
                                            width: "100%",
                                            border:
                                              index === 0
                                                ? "3px solid gold"
                                                : "1px solid #ccc",
                                          }}
                                        />
                                        <button
                                          type="button"
                                          onClick={() => removeImage(index)}
                                          className="btn btn-sm btn-danger position-absolute"
                                          style={{ top: 5, right: 5 }}
                                        >
                                          ×
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })}

                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>

                  {/* <p>Premium members can upload multiple images.</p> */}
                </div>
              </div>
            </div>
          </div>
          {/* Navigation Buttons */}
          <div className="row mb-5">
            <div className="col-12 mt-4 gap-2">
              <button
                onClick={handleDraftSubmit}
                className="Next"
                style={{ backgroundColor: "#939393" }}
              >
                Save as Draft
              </button>

              <button
                onClick={handleSubmit}
                disabled={imagelodaer}
                className="Next"
              >
                Make it live
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Loading Overlay */}
      {loading && (
        <div
          className="loading-overlay"
          style={{
            position: "fixed",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
            top: "0",
          }}
        >
          <div className="dot-spinner">
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
          </div>
        </div>
      )}
      <Fotter />
    </>
  );
}
